import { render } from "./VsCol.vue?vue&type=template&id=b931b064"
import script from "./VsCol.vue?vue&type=script&lang=js"
export * from "./VsCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__